import { render, staticRenderFns } from "./PlayingCard.vue?vue&type=template&id=8f518a86"
import script from "./PlayingCard.vue?vue&type=script&lang=js"
export * from "./PlayingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports